import React from "react";
import { Accordion, Container } from "react-bootstrap";
import clsx from "clsx";
import "./FAQ.scss";
import AccordianItem from "./AccordianItem";
import { Link } from "gatsby";

const FAQ_Page = ({ accordions }) => {
    if (!accordions || !accordions.faq) return null;

    const allFaqs = accordions.faq;

    return (
        <section
            className={'section-p faq-section'}
        >
            <div className="text-center m-auto faq-section-container container">
                <div className="tab-content">
                    <div className="head-faq mb-4">
                        {accordions.title ? <h3>{accordions.title}</h3> : null}
                    </div>

                    <div className="accordian-section">
                        <Accordion flush>
                            {allFaqs.map((faqItem, idx) => (
                                <AccordianItem
                                    accordion={{ FAQ_Content: faqItem.answer, FAQ_Title: faqItem.question}}
                                    eventKey={idx}
                                    key={faqItem.id || `faq-${idx}`}
                                />
                            ))}
                        </Accordion>
                    </div>
                    {accordions.Link && (
                        <div className="mt-4 d-flex justify-content-center">
                            <Link className="btn btn-pink" to={accordions.Link}>Read More</Link>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default FAQ_Page;